import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {connect} from 'react-redux';

function Email_setup_popup(props){

  function onSubmit(params){
    let update=false; for(let key in params.setup){if(params.setup[key]!=props.gmail.setup[key]){update=true;}}
    if(update==true){props.updateEmailSetup(params);}
  }

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={{setup:props.gmail.setup}}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='email_labels_popup_title' content={
          <div style={{width:'95vw', maxWidth:'600px', height:'300px'}}>
            <Grid container style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'20px'}}>
                <Grid item xs={8}><Text title='PS Inbox folder name' disabled name='setup.inbox_name'/></Grid><Grid item xs={4}></Grid>
                <Grid item xs={12}><div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Field name='setup.remove_from_inbox'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}  color="primary"/>}label={<Explanation_text inline text="Emails in this folder should be removed from the inbox."/>} />}</Field></div></Grid>
            </Grid>
            <Grid container style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'20px'}}>
                <Grid item xs={8}><Text title='PS Sent folder name' disabled name='setup.sent_name'/></Grid><Grid item xs={4}></Grid>
                <Grid item xs={12}><div style={{width:'calc(100% - 20px)', marginLeft:'10px'}}><Field name='setup.remove_from_sent'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange} color="secondary"/>}label={<Explanation_text inline text="Emails in this folder should be removed from the sent folder."/>}/>}</Field></div></Grid>
            </Grid>
          </div>
        }/>
        </form>
      )}
    </Form>
  );
}


export default connect(ss, dd)(Email_setup_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    updateEmailSetup:(params)=>{dispatch({type:'REQUEST_UPDATE_EMAIL_SETUP', payload:params})}
  }
}
